import React, { createContext, useContext, ReactNode } from 'react';
import { DatabaseProvider, useDatabaseContext } from './DatabaseContext';

interface AppContextType {
  isAppInitialized: boolean;
  apiUrl: string;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppProviderProps {
  children: ReactNode;
  isInitialized: boolean;
}

const AppProviderInner: React.FC<AppProviderProps> = ({ children, isInitialized }) => {
  const { apiUrl } = useDatabaseContext();
  
  return (
    <AppContext.Provider value={{ isAppInitialized: isInitialized, apiUrl }}>
      {children}
    </AppContext.Provider>
  );
};

export const AppProvider: React.FC<AppProviderProps> = ({ children, isInitialized }) => {
  return (
    <DatabaseProvider>
      <AppProviderInner isInitialized={isInitialized}>
        {children}
      </AppProviderInner>
    </DatabaseProvider>
  );
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
